module.exports = __webpack_public_path__ + "static/img/logo.611998f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/festival2021/logo.png
// module id = 453
// module chunks = 11